import { store } from "../../redux/storeConfig/store";

export const isVoiceDraftEditing = () => {
  const voice = store.getState().voiceAdd || {};
  return Boolean(voice.prefill && (voice.editingDraftId || voice.sessionId));
};

export const isVoiceSessionActive = () => {
  const voice = store.getState().voiceAdd || {};
  return Boolean(
    voice.sessionId ||
      voice.editingDraftId ||
      (voice.drafts && voice.drafts.length)
  );
};

export const skipVoiceCreate = (values) => {
  if (!isVoiceDraftEditing()) return false;
  return require("./saveDraftEdit").saveVoiceDraftEdit(values);
};
